import { render, staticRenderFns } from "./UserImpersonationWidget.vue?vue&type=template&id=504845a0&scoped=true&"
import script from "./UserImpersonationWidget.vue?vue&type=script&lang=js&"
export * from "./UserImpersonationWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserImpersonationWidget.vue?vue&type=style&index=0&id=504845a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504845a0",
  null
  
)

export default component.exports